import axios from "axios";

const getVisitorsData = () => {
	return axios.get("/api/stats/getVisitorsStats");
};

const getJobData = () => {
	return axios.get("/api/stats/getJobStats");
};

export { getVisitorsData, getJobData };



// WEBPACK FOOTER //
// ./src/actions/Analytics/analytics.js